import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormlyBaseConfigService } from '../../services/formly/formly-base-config/formly-base-config.service';
import { PprfTransactionAndPricingFormControlName } from './pprf-transaction-and-pricing-form/pprf-transaction-and-pricing-form.model';
import { PropertyPriceRegisterFormConfig } from './property-price-register-form.model';
import {
  getAttributesSearchFormModelNewInstance,
  PprfAttributesSearchFormModel,
} from './services/pprf-attributes-search-form/pprf-attributes-search-form.model';

@Injectable({
  providedIn: 'root',
})
export class PropertyPriceRegisterFormService extends FormlyBaseConfigService<
  PropertyPriceRegisterFormConfig,
  PprfAttributesSearchFormModel,
  PprfTransactionAndPricingFormControlName
> {
  override formModelCurrentState =
    new BehaviorSubject<PprfAttributesSearchFormModel>(
      getAttributesSearchFormModelNewInstance(),
    );
  override config = new BehaviorSubject<PropertyPriceRegisterFormConfig>(
    {} as PropertyPriceRegisterFormConfig,
  );
}
